module.exports = __webpack_public_path__ + "files/049a4737e36f99fbe6e77f5ecfc27f44.png";


//////////////////
// WEBPACK FOOTER
// ./images/googleLogo.png
// module id = 572
// module chunks = 60